import { Text, TextProps, Tooltip } from '@mantine/core';
import React from 'react';

import { formatDateTime, formatHumanizedDuration } from '@feature/utils';

export type DateTextProps = TextProps & {
  format?: 'iso';
  showAs: 'humanized' | 'date-time';
  date: string | number;
};

export const DateText: React.FC<DateTextProps> = ({ date, showAs, ...textProps }) => {
  return (
    <Text {...textProps}>
      {showAs === 'humanized' && <Tooltip label={formatDateTime(date)}>{formatHumanizedDuration(date)}</Tooltip>}
      {showAs === 'date-time' && formatDateTime(date)}
    </Text>
  );
};
